/*
 * Made with ♥ by Mister Topdesign
 * Radhalle rental enquiry wizard.
 */
(() => {
  const initRental = () => {
    const root = document.querySelector('[data-mt-rental]');
    if (!root || root.dataset.mtRentalReady === 'true') return;
    root.dataset.mtRentalReady = 'true';

    const modal = root.querySelector('#mt-rental-modal');
    const form = modal ? modal.querySelector('form') : null;
    if (!modal || !form) return;

    document.body.appendChild(modal);

    const steps = Array.from(modal.querySelectorAll('[data-mt-step]'));
    const progressBar = modal.querySelector('#mt-rental-progress');
    const progressText = modal.querySelector('#mt-rental-progress-text');
    const productImage = modal.querySelector('#mt-rental-product-image');
    const productName = modal.querySelector('#mt-rental-product-name');
    const categoryInput = modal.querySelector('#mt-rental-category');
    const nameInput = modal.querySelector('#mt-rental-product');
    const imageInput = modal.querySelector('#mt-rental-image');
    const priceInput = modal.querySelector('#mt-rental-price');
    const estimateInput = modal.querySelector('#mt-rental-estimate');
    const startInput = modal.querySelector('#mt-rental-start');
    const endInput = modal.querySelector('#mt-rental-end');
    const quantityInput = modal.querySelector('#mt-rental-quantity');
    const customerNameInput = modal.querySelector('#mt-rental-name');
    const personalHeading = modal.querySelector('[data-mt-personal-heading]');
    const summaryProduct = modal.querySelector('[data-mt-summary-product]');
    const summaryPeriod = modal.querySelector('[data-mt-summary-period]');
    const summaryDetails = modal.querySelector('[data-mt-summary-details]');
    const summaryPrice = modal.querySelector('[data-mt-summary-price]');
    const calendar = modal.querySelector('#mt-rental-calendar');
    const calendarGrid = calendar.querySelector('[data-mt-calendar-grid]');
    const monthLabel = calendar.querySelector('[data-mt-month-label]');
    const previousMonthButton = calendar.querySelector('[data-mt-month-prev]');
    const nextMonthButton = calendar.querySelector('[data-mt-month-next]');
    const fromOutput = calendar.querySelector('[data-mt-date-from]');
    const toOutput = calendar.querySelector('[data-mt-date-to]');
    const clearDatesButton = calendar.querySelector('[data-mt-date-clear]');
    const firstStepNextButton = modal.querySelector('[data-mt-step="1"] [data-mt-next]');
    const bikeOnlyFields = Array.from(modal.querySelectorAll('[data-mt-bike-only]'));

    let currentStep = 0;
    let activeTrigger = null;
    let selectedProduct = {
      name: '',
      image: '',
      category: '',
      shortRate: 0,
      longRate: 0
    };

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const calendarState = {
      view: new Date(today.getFullYear(), today.getMonth(), 1),
      start: null,
      end: null
    };

    const formatDate = (date) => date
      ? date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
      : '–';

    const sameDate = (left, right) => Boolean(
      left && right
      && left.getFullYear() === right.getFullYear()
      && left.getMonth() === right.getMonth()
      && left.getDate() === right.getDate()
    );

    const daysBetweenInclusive = () => {
      if (!calendarState.start || !calendarState.end) return 0;
      return Math.round((calendarState.end - calendarState.start) / 86400000) + 1;
    };

    const formatEuro = (amount) => new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(amount);

    const updateEstimate = () => {
      const days = daysBetweenInclusive();
      const quantity = Math.max(1, Number.parseInt(quantityInput.value, 10) || 1);
      const rate = days >= 7 ? selectedProduct.longRate : selectedProduct.shortRate;
      const estimate = days && rate ? days * rate * quantity : 0;

      if (days && rate) {
        const rateLabel = formatEuro(rate) + ' / Tag';
        const estimateLabel = 'ca. ' + formatEuro(estimate);
        priceInput.value = rateLabel;
        estimateInput.value = estimateLabel;
        summaryPrice.textContent = estimateLabel + ' · ' + rateLabel;
      } else {
        priceInput.value = '';
        estimateInput.value = '';
        summaryPrice.textContent = 'Wird nach Auswahl des Zeitraums berechnet';
      }
    };

    const updateSummary = () => {
      const quantity = Math.max(1, Number.parseInt(quantityInput.value, 10) || 1);
      const height = modal.querySelector('#mt-rental-height');
      const size = modal.querySelector('#mt-rental-size');
      const isBike = selectedProduct.category === 'Bike';

      summaryProduct.textContent = selectedProduct.name || 'Ausgewähltes Mietprodukt';
      summaryPeriod.textContent = calendarState.start && calendarState.end
        ? formatDate(calendarState.start) + ' – ' + formatDate(calendarState.end)
        : 'Noch nicht ausgewählt';

      if (isBike) {
        const heightText = height && height.value ? height.value + ' cm' : 'Körpergröße offen';
        const sizeText = size && size.value ? 'Wunschgröße ' + size.value : 'Größe wird beraten';
        summaryDetails.textContent = quantity + ' × Bike · ' + heightText + ' · ' + sizeText;
      } else {
        summaryDetails.textContent = quantity + ' × Zubehör';
      }

      updateEstimate();
    };

    const setStep = (index, shouldFocus = true) => {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));

      steps.forEach((step, stepIndex) => {
        const isActive = stepIndex === currentStep;
        step.classList.toggle('mt-is-active', isActive);
        step.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      const progress = ((currentStep + 1) / steps.length) * 100;
      progressBar.style.width = progress + '%';
      progressText.textContent = 'Schritt ' + (currentStep + 1) + ' von ' + steps.length;

      if (currentStep === steps.length - 1) updateSummary();

      if (shouldFocus) {
        window.setTimeout(() => {
          const activeStep = steps[currentStep];
          const focusTarget = activeStep.querySelector('input:not([type="hidden"]), select, textarea, button');
          if (focusTarget) focusTarget.focus();
        }, 40);
      }
    };

    const setBikeFields = (isBike) => {
      bikeOnlyFields.forEach((wrapper) => {
        wrapper.hidden = !isBike;
        wrapper.querySelectorAll('input, select, textarea').forEach((field) => {
          field.disabled = !isBike;
          if (field.dataset.mtRequiredForBike === 'true') field.required = isBike;
        });
      });
    };

    const resetCalendar = () => {
      calendarState.view = new Date(today.getFullYear(), today.getMonth(), 1);
      calendarState.start = null;
      calendarState.end = null;
      buildCalendar();
    };

    const openModal = (trigger) => {
      activeTrigger = trigger;
      form.reset();

      selectedProduct = {
        name: trigger.dataset.mtProductName || 'Ausgewähltes Mietprodukt',
        image: trigger.dataset.mtProductImage || '',
        category: trigger.dataset.mtCategory || '',
        shortRate: Number(trigger.dataset.mtRateShort) || 0,
        longRate: Number(trigger.dataset.mtRateLong) || 0
      };

      productName.textContent = selectedProduct.name;
      productImage.src = selectedProduct.image;
      productImage.alt = selectedProduct.name;
      categoryInput.value = selectedProduct.category;
      nameInput.value = selectedProduct.name;
      imageInput.value = selectedProduct.image;

      setBikeFields(selectedProduct.category === 'Bike');
      resetCalendar();
      setStep(0, false);
      updateSummary();

      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mt-rental-modal-open');
      window.setTimeout(() => modal.querySelector('.mt-rental-modal__close').focus(), 40);
    };

    const closeModal = () => {
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('mt-rental-modal-open');
      form.reset();
      selectedProduct = { name: '', image: '', category: '', shortRate: 0, longRate: 0 };
      productName.textContent = '–';
      productImage.removeAttribute('src');
      productImage.alt = '';
      categoryInput.value = '';
      nameInput.value = '';
      imageInput.value = '';
      priceInput.value = '';
      estimateInput.value = '';
      startInput.value = '';
      endInput.value = '';
      resetCalendar();
      setStep(0, false);
      if (activeTrigger) activeTrigger.focus();
      activeTrigger = null;
    };

    const validateStep = (step) => {
      const requiredFields = Array.from(step.querySelectorAll('[required]'))
        .filter((field) => !field.disabled && field.offsetParent !== null);

      for (const field of requiredFields) {
        if (!field.checkValidity()) {
          field.reportValidity();
          field.focus();
          return false;
        }
      }

      if (step.dataset.mtStep === '1' && (!calendarState.start || !calendarState.end)) {
        return false;
      }

      return true;
    };

    const buildCalendar = () => {
      calendarGrid.innerHTML = '';

      const year = calendarState.view.getFullYear();
      const month = calendarState.view.getMonth();
      const firstDay = new Date(year, month, 1);
      const leadingDays = (firstDay.getDay() + 6) % 7;
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      const currentMonth = new Date(today.getFullYear(), today.getMonth(), 1);

      monthLabel.textContent = firstDay.toLocaleDateString('de-DE', {
        month: 'long',
        year: 'numeric'
      });

      previousMonthButton.disabled = calendarState.view <= currentMonth;

      for (let index = 0; index < leadingDays; index += 1) {
        const placeholder = document.createElement('span');
        placeholder.className = 'mt-rental-calendar__placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        calendarGrid.appendChild(placeholder);
      }

      for (let day = 1; day <= daysInMonth; day += 1) {
        const date = new Date(year, month, day);
        const button = document.createElement('button');
        const isPast = date < today;

        button.type = 'button';
        button.className = 'mt-rental-calendar__day';
        button.textContent = String(day);
        button.disabled = isPast;
        button.setAttribute('aria-label', date.toLocaleDateString('de-DE', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }));

        if (isPast) button.classList.add('mt-is-past');
        if (sameDate(date, calendarState.start)) button.classList.add('mt-is-start');
        if (sameDate(date, calendarState.end)) button.classList.add('mt-is-end');
        if (
          calendarState.start
          && calendarState.end
          && date > calendarState.start
          && date < calendarState.end
        ) {
          button.classList.add('mt-is-in-range');
        }

        button.addEventListener('click', () => {
          if (!calendarState.start || calendarState.end) {
            calendarState.start = new Date(date);
            calendarState.end = null;
          } else if (date < calendarState.start) {
            calendarState.start = new Date(date);
          } else {
            calendarState.end = new Date(date);
          }

          buildCalendar();
        });

        calendarGrid.appendChild(button);
      }

      fromOutput.textContent = formatDate(calendarState.start);
      toOutput.textContent = formatDate(calendarState.end);
      startInput.value = calendarState.start ? formatDate(calendarState.start) : '';
      endInput.value = calendarState.end ? formatDate(calendarState.end) : '';
      firstStepNextButton.disabled = !(calendarState.start && calendarState.end);
      updateSummary();
    };

    previousMonthButton.addEventListener('click', () => {
      const previous = new Date(
        calendarState.view.getFullYear(),
        calendarState.view.getMonth() - 1,
        1
      );
      const currentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      if (previous >= currentMonth) {
        calendarState.view = previous;
        buildCalendar();
      }
    });

    nextMonthButton.addEventListener('click', () => {
      calendarState.view = new Date(
        calendarState.view.getFullYear(),
        calendarState.view.getMonth() + 1,
        1
      );
      buildCalendar();
    });

    clearDatesButton.addEventListener('click', () => {
      calendarState.start = null;
      calendarState.end = null;
      buildCalendar();
    });

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-mt-rental-trigger]');
      if (trigger) {
        event.preventDefault();
        openModal(trigger);
      }
    });

    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-mt-close]')) {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.target.closest('[data-mt-next]')) {
        event.preventDefault();
        const activeStep = steps[currentStep];
        if (validateStep(activeStep)) setStep(currentStep + 1);
        return;
      }

      if (event.target.closest('[data-mt-prev]')) {
        event.preventDefault();
        setStep(currentStep - 1);
      }
    });

    form.addEventListener('input', (event) => {
      if (event.target === customerNameInput && personalHeading) {
        const firstName = customerNameInput.value.trim().split(/\s+/)[0];
        personalHeading.textContent = firstName
          ? 'Fast geschafft, ' + firstName + '.'
          : 'Fast geschafft.';
      }
      if (event.target === quantityInput) updateSummary();
    });

    form.addEventListener('change', updateSummary);

    document.addEventListener('keydown', (event) => {
      if (modal.getAttribute('aria-hidden') !== 'false') return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = Array.from(modal.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href]'
      )).filter((element) => element.offsetParent !== null);

      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    buildCalendar();
    setStep(0, false);

    const success = modal.querySelector('[data-mt-rental-success]');
    const errors = modal.querySelector('[data-mt-rental-errors]');
    if (success || errors) {
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('mt-rental-modal-open');
      if (success) {
        steps.forEach((step) => {
          step.classList.remove('mt-is-active');
          step.setAttribute('aria-hidden', 'true');
        });
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRental, { once: true });
  } else {
    initRental();
  }
})();
